module.exports = __webpack_public_path__ + "media/nivel4.da8c8872.png";